export default "__VITE_ASSET__1d07a6ae__"